<div class="form-coupon">
    @if (formPills.length) {
        <ms-scroll-adapter [msScrollSelectedInView]="active && active!.id" [scrollItems]="formPills">
            <div class="form-coupon-pills">
                @for (item of formPills; track item.id) {
                    <button class="pill-alignment" ds-pill size="medium" [selected]="item.active" (click)="onFormSwitch(item)">
                        {{ item.title }}
                    </button>
                }
            </div>
        </ms-scroll-adapter>
    }
    <ms-form-coupon-quick-selector (select)="addToBetslip($event)"></ms-form-coupon-quick-selector>
</div>
